<template>
  <!-- 新-代理管理首页 -->
  <div class="firm-body">
    <div class="title-Individual-center">
      企业中心 <i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">代理服务</span>
      <span class="service-info"
        >服务代理：南阳圆税财税服务有限公司（统一社会信用代码：91411303MADDFC8U3C）许可证书编号：<span
          class="certificate-link"
          @click="goToCertificate"
          >DLJZ41130320260015</span
        ></span
      >
    </div>
    <!-- 主体部分 -->
    <div class="firm-Content-subject">
      <div class="content">
        <div
          v-for="(item, index) in listArr"
          :key="index"
          v-show="item.ShowHide"
          class="content-box firm-clickable"
          @click="handelClick(item)"
        >
          <div class="content-top">
            <img :src="item.imgUrl" :alt="item.serviceName" />
          </div>
          <div class="content-bottom">
            <div class="title">{{ item.serviceName }}</div>
            <div class="ServiceItem">
              {{ item.serviceContent }}
            </div>
            <div class="agreement" v-if="item.serviceAgreement">
              <div class="agreement-check" @click.stop>
                <el-checkbox v-model="item.checked"></el-checkbox>
              </div>
              <div class="agreement-p firm-clickable">
                已阅读并同意侦迹云<span
                  @click.stop="handelAgreement(item.Agreement)"
                  class="agreement-link"
                  >《{{ item.Agreement }}》</span
                ><span
                  v-if="item.Agreement1"
                  @click.stop="handelAgreement(item.Agreement1)"
                  class="agreement-link"
                  >《{{ item.Agreement1 }}》</span
                ><span
                  v-if="item.Agreement2"
                  @click.stop="handelAgreement(item.Agreement2)"
                  class="agreement-link"
                  >《{{ item.Agreement2 }}》</span
                ><span
                  v-if="item.Agreement3"
                  @click.stop="handelAgreement(item.Agreement3)"
                  class="agreement-link"
                  >《{{ item.Agreement3 }}》</span
                >。允许侦迹云统一管理本人账号记账信息
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ProtocolPopup
      :dialogAgr="dialogAgr"
      :agreement="''"
      @handleClose="dialogAgr = false"
    ></ProtocolPopup>
  </div>
</template>

<script>
import GroupJz from "@/assets/imgs/img/proxy-service/proxy-bookkeeping.svg";
import GroupFw from "@/assets/imgs/img/proxy-service/proxy-other.svg";
import GroupKh from "@/assets/imgs/img/proxy-service/proxy-customer.svg";
import GroupTk from "@/assets/imgs/img/proxy-service/proxy-refund.svg";
import GroupFp from "@/assets/imgs/img/proxy-service/proxy-invoice.svg";
import ProtocolPopup from "../../../signin/components/ProtocolPopup.vue";
import * as API from "@/assets/api/Agency/Enterprise.js";
import { companyPageMenu } from "../../../../assets/api/Agency/Enterprise";
export default {
  data() {
    return {
      listArr: [
        {
          id: 1,
          serviceName: "代理记账",
          serviceContent:
            "1.财务处理：审核单据、记账、出具财务报表、凭证账簿归档\n2.纳税申报：增值税、个税、企业所得税、年度所得税汇算清缴、残保金等申报\n3.工商年报申报\n4.财税答疑、税务风险提示",
          serviceAgreement: true, //是否有服务协议
          checked: false, //协议确认
          url: "/Bookkeeping",
          Agreement: "企业服务协议", // 协议
          Agreement1: "代理记账专项协议", // 协议
          Agreement2: "付费服务协议", // 协议
          Agreement3: "侦迹云增值服务协议", // 协议
          ShowHide: true, //后台控制是否显示
          imgUrl: GroupJz,
        },
        {
          id: 2,
          serviceName: "其它代理服务",
          serviceContent:
            "新设立服务、注销服务、变更服务、知识产权服务、资质服务、标书制作服务、审计服务、评估服务、税务筹划服务",
          serviceAgreement: true, //是否有服务协议
          checked: false,
          url: "/ProxyOther",
          Agreement: "企业服务协议", // 协议
          Agreement1: "代理记账专项协议", // 协议
          Agreement2: "付费服务协议", // 协议
          Agreement3: "侦迹云增值服务协议", // 协议
          ShowHide: true, //后台控制是否显示
          imgUrl: GroupFw,
        },
        {
          id: 3,
          serviceName: "客户管理",
          serviceContent: "便捷管理客户信息",
          serviceAgreement: true, //是否有服务协议
          checked: false,
          url: "/Customer",
          Agreement: "客户推荐协议", // 协议
          ShowHide: true, //后台控制是否显示
          imgUrl: GroupKh,
          val: "proxy:company:customer",
        },
        {
          id: 4,
          serviceName: "退款记录",
          serviceContent: "展示企业服务中代理记账，其他服务的退款记录",
          serviceAgreement: false, //是否有服务协议
          checked: true,
          url: "/Refund",
          ShowHide: true, //后台控制是否显示
          imgUrl: GroupTk,
          val: "proxy:company:refund:record",
        },
        {
          id: 5,
          serviceName: "发票管理",
          serviceContent: "进销项发票记录",
          serviceAgreement: false, //是否有服务协议
          checked: true,
          url: "/ProxyService/Invoice",
          Agreement: "客户管理协议", // 协议
          ShowHide: true, //后台控制是否显示
          imgUrl: GroupFp,
          val: "proxy:invoice:manage",
        },
      ], //企业服务

      Classification: "", //1企业服务 2同行代理
      RealName: true, //是否实名
      dialogAgr: false, //协议弹窗
    };
  },
  computed: {
    isGuest() {
      const user = this.$store.getters.getUser;
      return !(user && user.id);
    },
  },
  watch: {
    listArr: {
      handler(newVal) {
        if (this.isGuest) return;
        // 保存已勾选的协议ID到 localStorage，使用公司ID区分不同用户
        const companyId = this.$store.getters.getCompany.id;
        const checkedIds = newVal.filter(item => item.checked).map(item => item.id);
        localStorage.setItem(`proxyAgreementChecked_${companyId}`, JSON.stringify(checkedIds));
      },
      deep: true
    }
  },
  components: { ProtocolPopup },
  created() {
    // 未登录：不调接口，本地 listArr 全部展示
    this.listArr.forEach((item) => {
      item.ShowHide = true;
    });
    if (this.isGuest) return;

    API.queryCompanyPaySetting().then((res) => {
      if (res.code == 0) {
        localStorage.setItem("PaymentPwd", res.data);
      }
    });

    // 从 localStorage 恢复协议勾选状态，使用公司ID区分不同用户
    const companyId = this.$store.getters.getCompany.id;
    const agreementChecked = localStorage.getItem(`proxyAgreementChecked_${companyId}`);
    if (agreementChecked) {
      const checkedIds = JSON.parse(agreementChecked);
      this.listArr.forEach(item => {
        if (checkedIds.includes(item.id)) {
          item.checked = true;
        }
      });
    }

    // if (this.$route.query.key != "" && this.$route.query.key != undefined) {
    //   this.Classification = this.$route.query.key;
    //   var num = this.$route.query.key == 1 ? 0 : 1;
    //   var type = this.$route.query.key == 1 ? 11 : 22;

    //   this.$tool.CompanyPageMenu(num, type).then((res) => {
    //     for (var i in this.listArr) {
    //       for (var k in res) {
    //         if (res[k].label == this.listArr[i].serviceName) {
    //           this.listArr[i].ShowHide = res[k].onOrOff;
    //         } else if (
    //           this.listArr[i].serviceName == "客户管理" ||
    //           this.listArr[i].serviceName == "退款记录"
    //         ) {
    //           this.listArr[i].ShowHide = true;
    //         }
    //       }
    //     }
    //   });
    // }
  },
  destroyed() {},
  methods: {
    //协议跳转
    handelAgreement(agreementName) {
      if (agreementName) {
        const route = this.$router.resolve({
          path: "/AboutUs/Express",
          query: { name: agreementName },
        });
        window.open(route.href, '_blank');
      }
    },
    // 跳转到资质证书页面
    goToCertificate() {
      const route = this.$router.resolve({ path: '/AboutUs/Publicity' });
      window.open(route.href, '_blank');
    },
    // 返回
    handelBack() {
      this.$router.push({
        path: "/ProxyService",
      });
    },
    // 点击每个模块跳转
    handelClick(item) {
      // 未登录：不调接口，勾选协议后直接进入（子页也走模拟/拦截）
      if (this.isGuest) {
        if (item.serviceAgreement == true && item.checked != true) {
          this.$tool.PromptBox("warning", "请先阅读并勾选相关协议");
          return;
        }
        this.$router.push({ path: item.url, query: { key: item.id } });
        return;
      }
      if (item.id == 1 || item.id == 2) {
        // 请求接口 获取页面功能
        var data = {
          data: {
            proxyModel: 0,
            creditCode: this.$store.getters.getCompany.creditCode, //当前企业信用代码
            menuCode: 11, //父级
          },
        };
        companyPageMenu(data).then((res) => {
          if (res.code == 0) {
            //判断返回data不为空
            if (
              res.data != [] &&
              res.data != "" &&
              res.data != null &&
              res.data != undefined
            ) {
              // 地区有开启，判断代理记账/其它服务是否全部开启
              if (item.id == 1 && res.data[0].onOrOff == false) {
                //代理记账无开启
                this.$tool.PromptBox(
                  "error",
                  `该地区暂未开启${item.serviceName}`
                );
              } else if (item.id == 2 && res.data[1].onOrOff == false) {
                // 其它服务无开启
                this.$tool.PromptBox(
                  "error",
                  `该地区暂未开启${item.serviceName}`
                );
              } else {
                //页面功能有开启
                if (item.serviceAgreement == true && item.checked == true) {
                  this.$router.push({
                    path: item.url,
                    query: { key: item.id },
                  });
                } else if (item.serviceAgreement == false) {
                  this.$router.push({
                    path: item.url,
                    query: { key: item.id },
                  });
                } else {
                  this.$tool.PromptBox(
                    "warning",
                    "请先阅读并勾选相关协议"
                  );
                }
              }
            } else {
              // 页面没有代理服务功能开启
              this.$tool.PromptBox(
                "error",
                `该地区暂未开启${item.serviceName}`
              );
            }
          }
        });
      } else {
        // ✅ 新增：权限校验逻辑
        const permissionCodesStr = localStorage.getItem("permissionCodes");
        const permissionArr = permissionCodesStr
          ? JSON.parse(permissionCodesStr)
          : [];

        // 无对应权限 → 中止操作，提示权限不足
        if (item.val && !permissionArr.includes(item.val)) {
          this.$message.warning("权限不足，无法执行操作");
          return;
        }
        // 其他的先看是否勾选用户协议在进行对应显示
        if (item.serviceAgreement == true && item.checked == true) {
          this.$router.push({ path: item.url, query: { key: item.id } });
        } else if (item.serviceAgreement == false) {
          this.$router.push({ path: item.url, query: { key: item.id } });
        } else {
          this.$tool.PromptBox("warning", "请先阅读并勾选相关协议");
        }
      }
    },
  },
};
</script>

<style scoped lang="less">
// 选择框的大小
/deep/.el-checkbox__inner {
  width: 13px;
  height: 13px;
  margin-right: 5px;
  border: 1px solid #409eff ;
  border-radius: 50px;
}

.title-Individual-center {
  display: flex;
  align-items: center;
  height: auto;
  line-height: 20px;
  margin-bottom: 20px;

  .el-icon-arrow-right {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 14px;
    line-height: 1;
    font-size: 12px;
    margin: 0 5px;
    transform: translateY(-1px);
  }

  .span-Individual-center {
    line-height: 20px;
  }

  .service-info {
    margin-left: auto;
    font-size: 12px;
    color: #666666;
    font-weight: 400;
    text-align: right;
    line-height: 1.5;
    cursor: default;

    .certificate-link {
      color: #409eff ;
      cursor: pointer;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}

.firm-body {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  .firm-Content-subject {
    width: 100%;
    min-height: 620px;
    box-sizing: border-box;
    border-radius: 5px;
    .content {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      gap: 16px;
      margin: 0;
      box-sizing: border-box;
      .content-box {
        width: calc((100% - 32px) / 3);
        background: #ffffff;
        box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        margin-bottom: 0;
        box-sizing: border-box;

        .content-top {
          width: 100%;
          height: auto;
          aspect-ratio: 420 / 100;
          flex-shrink: 0;
          border-radius: 10px 10px 0 0;
          overflow: hidden;
          background-color: #f5f7fa;
          line-height: 0;

          img {
            width: 100%;
            height: 100%;
            display: block;
            object-fit: fill;
          }
        }

        .content-bottom {
          flex: 1;
          padding: 12px 16px 16px;
          display: flex;
          flex-direction: column;
          box-sizing: border-box;

          .title {
            height: 18px;
            font-family: PingFangSC-Medium;
            font-size: 18px;
            color: #333333;
            font-weight: 600;
            flex-shrink: 0;
          }

          .ServiceItem {
            font-family: PingFangSC-Medium;
            font-size: 12px;
            color: #666666;
            font-weight: 400;
            margin-top: 10px;
            line-height: 1.6;
            white-space: pre-line;
            flex-shrink: 0;
          }

          .agreement {
            width: 100%;
            display: flex;
            align-items: flex-start;
            margin-top: auto; // 统一沉底对齐
            padding-top: 12px;
            flex-shrink: 0;

            .agreement-check {
              display: flex;
              margin-right: 4px;
              margin-top: 1px;
            }

            .agreement-p {
              flex: 1;
              font-family: PingFangSC-Medium;
              font-size: 12px;
              color: #666666;
              font-weight: 400;
              line-height: 1.5;
            }

            .agreement-link {
              color: #409eff;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>
